// extracted by mini-css-extract-plugin
module.exports = {"rating":"Rating_rating__6O_ui","ratingText":"Rating_ratingText__s2vMm","ratingValue":"Rating_ratingValue__KS_rp","baseColor":"Rating_baseColor__lBxZu"};